import { PersonDateOfBirthFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

/** Дата рождения сотрудника — поле под защитой, поэтому показывается через `Value`. */
export function PersonDateOfBirth({
  data,
}: {
  data?: Hidable<PersonDateOfBirthFragment>;
}) {
  return (
    <Value data={data}>{(person) => <Value data={person.dateOfBirth} />}</Value>
  );
}
